import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import * as api from './api/api';
import * as socket from './socket';
import config from './config/index';

import { BrowserRouter } from 'react-router-dom';

api.initialize(config);
socket.initialize(config.ws_address);

ReactDOM.render(
  <BrowserRouter basename="/imms">
    <App />
  </BrowserRouter>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// basename = "/imms
